export { default } from './leasing-details';
